import type { Props } from '.'

export type Quote = {
  affiliation?: string
  name?: string
  quote: string
}

export type Raw = {
  acfFcLayout: 'quote_list'
  quoteList: Quote[]
}

export type Parsed = {
  name: 'QuoteList'
  props: Props
}

export function parser(rawComponent: Raw): Parsed {
  return {
    name: 'QuoteList',
    props: { quotes: rawComponent.quoteList },
  }
}
